import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortByName'
  })
  export class OrderByNamePipe implements PipeTransform {
    transform(items: any[]): any[] {
      return items.sort((a, b) => {
          return a.name < b.name ? -1 : (a.name > b.name ? 1 : 0);
      });
    }
  }